import BoletoAPI from '@/api/boleto'

export default {
  clear({ commit }) {
    commit('SET_BOLETOS', [])
  },
  fetchBoletos({ commit }, params) {
    try {
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        BoletoAPI.listBoleto(params.pagina)
          .then(response => {
            commit('ADD_BOLETOS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    } finally {
      commit('SET_LOADING', false)
    }
  },
}
